import { useOktaAuth } from '@okta/okta-react';
import { useNavigate } from 'react-router-dom';

const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const navigate = useNavigate();

  if (!authState || authState.isPending) {
    return <div>Loading...</div>; // Wait for Okta to restore tokens
  }

  if (!authState.isAuthenticated) {
    navigate('/login');
    // oktaAuth.signInWithRedirect();
    return null;
  }

  return children;
};

export default RequireAuth;
